/**
 * Admin dialog message protocol shared across hosts.
 *
 * Defines dialog <-> parent postMessage payloads for admin tooling.
 */
// ═══════════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════════
export function sendAdminToParent(message) {
    try {
        Office.context.ui.messageParent(JSON.stringify(message));
    }
    catch (error) {
        console.error("[sendAdminToParent] Error calling messageParent:", error);
        throw error;
    }
}
export function sendAdminToDialog(dialog, message) {
    try {
        dialog.messageChild(JSON.stringify(message));
    }
    catch (error) {
        console.error(`[sendAdminToDialog] Error sending message ${message.action}:`, error);
    }
}
export function parseAdminParentMessage(messageString) {
    try {
        return JSON.parse(messageString);
    }
    catch {
        console.error("[AdminDialog] Failed to parse parent message:", messageString);
        return null;
    }
}
export function parseAdminDialogMessage(messageString) {
    try {
        return JSON.parse(messageString);
    }
    catch {
        console.error("[Commands] Failed to parse admin dialog message:", messageString);
        return null;
    }
}
